import { useEffect, useRef } from "react";
import XDiv from "./XDiv";

/**
 * 
 * @typedef {Object} xanchorparams
 * @property {Function} onMounted
 * @property {String} scrollDivID
 * 
 * @param {xanchorparams} param0 
 * @returns 
 */
function XAnchor({
  onMounted = null,
  scrollDivID = "__scroll__"
}){

  const ref = useRef(null);

  useEffect(() => {

    const ScrollIntoView = (offset) => {
     
      let el = document.getElementById(scrollDivID);
      let ePos = ref.current.getBoundingClientRect().top;
      let offsetPos = ePos + el.scrollTop - offset;
      
      el.scrollTo({
        top: offsetPos,
        behavior: "smooth"
      }); 

    };

    let callbacks = {
      ScrollIntoView: ScrollIntoView
    };

    onMounted?.(callbacks);

  }, [onMounted, scrollDivID]);

  return (
    <XDiv forwardRef={ref} opacity={0}/>
  );
}

export default XAnchor;